import { keyframes, SxProps } from "@mui/material";

const stopPulse = keyframes`
  0% { stop-opacity: 0.35; }
  50% { stop-opacity: 0.9; }
  100% { stop-opacity: 0.35; }
  `;
export const skeletonLinearGradientStyle: SxProps = {
  // Target bar elements and animate their opacity to mimic a skeleton pulse
  "#Gradient stop": {
    animation: `${stopPulse} 1.6s ease-in-out infinite`,
  },
  "#Gradient stop:nth-of-type(2)": {
    animationDelay: "0.25s",
  },
};
